












import {Vue, Component} from 'vue-property-decorator';
import {State} from 'vuex-class';
import Logo from '@/components/common/Logo.vue';
@Component({
  components: { Logo },
})
export default class LoginHeader extends Vue {
  @State private view!: object;
}
